import React from 'react';
import c from 'classnames';
import s from './InputLabelSubText.scss';

interface Props {
  className?: string;
}

const InputLabelSubText: React.FC<React.PropsWithChildren<Props>> = ({ className, children }) => {
  return <div className={c(s['root'], className)}>{children}</div>;
};
InputLabelSubText.displayName = 'InputLabelSubText';

export default InputLabelSubText;
